/** Minimal tree-node shape for Teams sidebar navigation links. */
export type TeamTreeLinkNode = {
  id: string;
  loading?: boolean | undefined;
  isParentType?: boolean | undefined;
  group?: { id?: string | undefined; childTeams?: unknown[] | undefined };
  children?: unknown[] | Record<string, unknown> | null | undefined;
};

export type SidebarTeamTreeLinkContext = {
  getTeamDetailsPath: (group: { id: string }) => string;
};

/**
 * Link targets for the Teams sidebar. Sidebar rows always link to the
 * team's own (tab-aware) details page — expanding a parent team's
 * sub-teams is a separate chevron-toggle action, not a link target.
 */
export const getSidebarTeamTreeLinkTo = (
  node: TeamTreeLinkNode,
  { getTeamDetailsPath }: SidebarTeamTreeLinkContext
): string | null => {
  if (!node?.id || !node.group) {
    return null;
  }

  const group = node.group as { id: string; childTeams?: unknown[] };

  return getTeamDetailsPath(group);
};
